import { ADD_SYSTEM_NOTIFICATION_LIST, ADD_SYSTEM_NOTIFACTION, SYNCHRONIZATION_STARTED } from './actionTypes';

const getInitialState = () => ({
  synchronized: false,
  items: [],
});

export default function (state = getInitialState(), action) {
  switch (action.type) {
    case ADD_SYSTEM_NOTIFICATION_LIST:
      return Object.assign({}, state, {
        items: [...action.payload.notifications, ...state.items],
      });
    case ADD_SYSTEM_NOTIFACTION:
      return Object.assign({}, state, {
        items: [action.payload.notification, ...state.items],
      });
    case SYNCHRONIZATION_STARTED:
      return Object.assign({}, state, {
        synchronized: true,
      });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/services/systemNotifications/reducer.js